/**
 * Moves the cart-page app block immediately before the checkout button on
 * mobile. On wider screens, the block is restored to its original theme
 * editor position.
 */
class MobileDeliveryDatetimePosition extends HTMLElement {
  #mediaQuery = window.matchMedia('(max-width: 749px)');
  #observer;
  #scheduled = false;

  connectedCallback() {
    this.#mediaQuery.addEventListener('change', this.#schedulePosition);
    this.#observer = new MutationObserver(this.#schedulePosition);

    const cartPage = this.closest('.cart-page');
    if (cartPage) {
      this.#observer.observe(cartPage, { childList: true, subtree: true });
    }

    this.#schedulePosition();
  }

  disconnectedCallback() {
    this.#mediaQuery.removeEventListener('change', this.#schedulePosition);
    this.#observer?.disconnect();
  }

  #schedulePosition = () => {
    if (this.#scheduled) return;

    this.#scheduled = true;
    queueMicrotask(() => {
      this.#scheduled = false;
      this.#position();
    });
  };

  #position() {
    const cartPage = this.closest('.cart-page');
    if (!cartPage) return;

    const deliveryBlock = cartPage.querySelector('.cart-page__more-blocks');
    const checkoutButtons = cartPage.querySelector('.cart__ctas');
    if (!deliveryBlock) return;

    if (this.#mediaQuery.matches && checkoutButtons) {
      if (deliveryBlock.nextElementSibling !== checkoutButtons) {
        checkoutButtons.before(deliveryBlock);
      }
      return;
    }

    if (this.nextElementSibling !== deliveryBlock) {
      this.after(deliveryBlock);
    }
  }
}

if (!customElements.get('mobile-delivery-datetime-position')) {
  customElements.define('mobile-delivery-datetime-position', MobileDeliveryDatetimePosition);
}
